export const COL_FILTER = {
  cols: 12,
  xl: 3,
  lg: 3,
  md: 3,
  styleMaxWidth: '',
  style: '',
  class: 'pa-2',
};

export const BTN_FILTER = {
  style: 'height: 50px; width: 200px; border-radius: 10px;',
};

export const HEADER_FIRST_LINE = {
  class: 'font-weight-bold foreground--text',
  style: 'font-size: 18px;',
};

export const HEADER_SECOND_LINE = {
  class: 'font-weight-regular foreground--text',
  style: 'font-size: 18px;',
};

export const BODY_FIRST_LINE = {
  class: 'font-weight-regular primary--text',
  style: 'font-size: 18px;',
};

export const BODY_SECOND_LINE = {
  class: 'font-weight-light primary--text',
  style: 'font-size: 18px;',
};

export const BODY_SECOND_LINE_STATUS = {
  class: 'font-weight-light primary--text d-flex justify-start',
  style:
    'font-size: 18px; background: var(--v-muted-base) 0% 0% no-repeat padding-box; border-radius: 10px; padding: 0 14px;',
};

export const SELECT_FOOTER = {
  style: "max-width: 80px; width: 80px; margin-right: 50px;",
}

export const BTN_FOOTER = {
  style: 'border-radius: 10px !important; height: 50px !important; min-width: 300px !important; max-width: 300px !important;',
};

export const BTN_ACTION = {
  style: 'height: 50px; width: 300px; border-radius: 10px;',
};

export const BTN_UPLOAD = {
  style: 'height: 50px; width: 200px; border-radius: 10px;',
};

export const BTN_EXPORT = {
  style: 'height: 50px; width: 160px; border-radius: 10px;',
};